import React from 'react';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';

const useStyles = createUseStyles({
    th: {
        top: 0,
        zIndex: 1,
        padding: 0,
        backgroundColor: colors.grayOne,
        overflow: 'hidden',
        position: 'sticky',
    },

    thFocusable: {
        cursor: 'text',
        '&:focus-within': {
            outline: `1px solid ${colors.blueLink}`,
            outlineOffset: -1,
        },
    },
    headerContent: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        minHeight: 56,
        overflow: 'hidden',
        padding: '8px 12px',
    },
});

interface DynamicGridHeaderCellProps {
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
    readOnly?: boolean;
    rowSpan?: number;
    colSpan?: number;
    onClick?: React.MouseEventHandler<HTMLTableCellElement>;
}

export function DynamicGridHeaderCell({
    className,
    children,
    contentClassName,
    readOnly = false,
    onClick,
    rowSpan,
    colSpan,
}: DynamicGridHeaderCellProps) {
    const classes = useStyles();
    const thClassName = `${classes.th} ${!readOnly ? classes.thFocusable : ''} ${className ?? ''}`;

    return (
        <th rowSpan={rowSpan} colSpan={colSpan} className={thClassName} onClick={!readOnly ? onClick : undefined}>
            <div className={`${classes.headerContent} ${contentClassName ?? ''}`}>{children}</div>
        </th>
    );
}
